import styled from 'styled-components';
import { darkColors } from '@tryhackme/thm-ui-components';

import { StyledLoading } from 'src/common/components';

export const StyledWrapperButton = styled.div`
  margin-top: 2.4rem;
  height: 3.6rem;

  button {
    width: 100%;
  }
`;

export const StyledEmptyMessage = styled.p`
  color: ${({ theme }) => theme.colors.grey[500]};
  text-align: center;
  margin: 4rem 0;
`;

export const StyledRoomLoading = styled(StyledLoading)`
  background: linear-gradient(
    to right,
    ${darkColors.loading.primary},
    ${darkColors.loading.secondary},
    ${darkColors.loading.primary}
  );
`;

export const StyledRoomItem = styled.li`
  margin-top: 1.6rem;
`;
